import { ImageBackGround } from '../image-background';
import SmoothScroll from "smooth-scroll";
import imageBg from '../../images/home.png'

export const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
});

export const Home = () => {
    
    return (
        <>
            <ImageBackGround imageBg={imageBg}/>
        </>
    );
};